import { useState, useEffect } from "react";
import { useParams,useLocation,  useNavigate } from "react-router-dom";
import { Table, Statistic, Card, Row, Col, Button, Spin, Alert, DatePicker } from "antd";
import moment from "moment-timezone";
import { ArrowLeftOutlined } from "@ant-design/icons";

export default function HistoriqueControleur({route,navigation}) {
 // const { id,nom } = useParams();
 const location = useLocation();
  const { id, nom, telephone } = location.state || {};
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const API_BASE = "https://srv968119.hstgr.cloud";

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/users/controleur/historique/${id}`);
        if (!response.ok) throw new Error("Erreur réseau");
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Erreur:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const filteredChecks = dateRange.length === 2
    ? data?.checks.filter(check => {
        const checkDate = moment(check.createdAt).tz('Africa/Niamey');
        return checkDate.isBetween(dateRange[0], dateRange[1], 'day', '[]');
      })
    : data?.checks;

  const columns = [
    {
      title: 'Date',
      dataIndex: 'createdAt',
      key: 'date',
      render: (date) => moment(date).tz('Africa/Niamey').format('DD/MM/YYYY HH:mm'),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: 'Nom et Prénom',
      dataIndex: 'nom',
      key: 'vehicule',
      render: (text, record) => `${text} ${record.prenom || ''}`,
    },
    {
      title: 'Franchise',
      dataIndex: 'franchise',
      key: 'franchise',

    },

  ];

  if (loading) return (
    <div className="flex justify-center items-center h-screen">
      <Spin size="large" tip="Chargement des données..." />
    </div>
  );

  if (error) return (
    <div className="p-7">
      <Alert
        message="Erreur"
        description={`Impossible de charger les données: ${error}`}
        type="error"
        showIcon
        action={
          <Button size="small" onClick={() => window.location.reload()}>
            Réessayer
          </Button>
        }
      />
    </div>
  );

  if (!data) return (
    <div className="p-7">
      <Alert
        message="Aucune donnée"
        description="Aucune donnée disponible pour ce contrôleur"
        type="warning"
        showIcon
      />
    </div>
  );

  return (
    <div className="p-24 bg-gray-50  w-[90%] ml-[5%]">
      <div className="flex items-center mb-6">

        <div className="text-2xl font-bold dark:text-gray-800 text-black ">Historique du Contrôleur : {nom} - {telephone}</div>
      </div>

      <Row gutter={16} className="mb-6">
        <Col span={8}>
          <Card>
            <Statistic
              title="Checks aujourd'hui"
              value={data.stats.aujourdhui}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Checks ce mois"
              value={data.stats.ce_mois}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Total checks"
              value={data.stats.total}
            />
          </Card>
        </Col>
      </Row>

      <div className="mb-4">
        <DatePicker.RangePicker
          style={{ width: '100%' }}
          onChange={(dates) => setDateRange(dates)}
          disabledDate={(current) => current && current > moment().endOf('day')}
        />
      </div>

      <Card title="Liste des vérifications" className="shadow">
        <Table
          columns={columns}
          dataSource={filteredChecks}
          rowKey="id_Check"
          pagination={{ pageSize: 10 }}
          scroll={{ x: true }}
          loading={loading}
          locale={{
            emptyText: "Aucune vérification trouvée"
          }}
        />
      </Card>
    </div>
  );
}
